import { useEffect, useState } from 'react'
import { collection, query, where, onSnapshot } from 'firebase/firestore'
import { db } from '../firebaseConfig'

export function usePendingMissionClaims() {
  const [count, setCount] = useState(0)

  useEffect(() => {
    const q = query(
      collection(db, 'mission_claim_logs'),
      where('approved', '==', false)
    )

    const unsub = onSnapshot(q, (snap) => {
      setCount(snap.size)
    })

    return () => unsub()
  }, [])

  return count
}
